module.exports = __webpack_public_path__ + "assets/img/image-preview.40fe5936.gif";